/*
 * nprogress 封装, 这个动画只能用于react-loadable
 * 因为在获取到真实组件之前会触发loading的 `componentWillMount`生命周期函数
 * 在获取到真实组件后loading的`componentWillUnmount`会触发
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-08-06 15:15:55
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-08-06 15:37:28
 */

import * as React from 'react';
import nprogress from 'nprogress';

export default class NProgressLoading extends React.PureComponent {
	componentWillMount () {
		nprogress.start();
	}

	componentWillUnmount () {
		nprogress.done();
	}

	render () {
		return null;
	}
}
